import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Route, RouterModule } from '@angular/router';
import { ViewContentComponent } from './view-content/view-content.component';

const routes: Route[] = [];

@NgModule({
  imports: [CommonModule, RouterModule.forChild(routes)],
  declarations: [ViewContentComponent],
  exports: [ViewContentComponent]
})
export class CoreLayoutContentViewModule {}
